// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import NewsletterSubscription from './NewsletterSubscription';

const reportConsent = (email, isEnabled, text, callback) => {
    const request = new Ajax.Request(Jsw.prepareUrl('/my-profile/report-consent'), {
        method: 'post',
        parameters: {
            email,
            text,
            isEnabled: Number(isEnabled),
        },
        onComplete() {
            callback(request.success());
        },
    });
};

module.exports = ({ container, locale, ...props }) => {
    render((
        <LocaleProvider messages={locale}>
            <NewsletterSubscription reportConsent={reportConsent} {...props} />
        </LocaleProvider>
    ), container);
};



// WEBPACK FOOTER //
// ./app/newsletter-subscription/index.js